import { render, staticRenderFns } from "./CollapseMenuItem.vue?vue&type=template&id=fc7401ba&"
import script from "./CollapseMenuItem.vue?vue&type=script&lang=js&"
export * from "./CollapseMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports